import styled from "styled-components";

export const Logo = styled.img`
  width: 101px;
  height: 118px;
  padding-top: 26px;
  background-color: #000000;
  @media (max-width: 768px) {
    width: 40px;
    height: 46px;
    padding-top: 10px;
  }
`;
